'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

var PAGE_COUNT = exports.PAGE_COUNT = 'pageCount';
var VISIT_COUNTDOWNS = exports.VISIT_COUNTDOWNS = 'visitCountdowns';
var VISITS_TO_WAIT = exports.VISITS_TO_WAIT = 'visitsToWait';
var CHANNEL_NAME = exports.CHANNEL_NAME = 'channelName';
var DEFAULT_CHANNEL = exports.DEFAULT_CHANNEL = 'broadcast';

var ACTIVE_VISIT_DURATION = exports.ACTIVE_VISIT_DURATION = 6 * 60 * 60; // 6 hours in seconds
var PERMA_DURATION = exports.PERMA_DURATION = 365 * 24 * 60 * 60; // 1 year in seconds

var MESSAGING_STATUS = exports.MESSAGING_STATUS = {
    LOADING: 0,
    READY: 1,
    FAILED: -1
};


//////////////////
// WEBPACK FOOTER
// ./~/progressive-web-sdk/dist/store/push-messaging/constants.js
// module id = 57
// module chunks = 0